<template>
    <v-dialog v-model="ShowDialog" max-width="800" persistent>
        <v-card class="rounded-xl">
            <v-card-title class="headline primary gradient-primary white--text">
                <div class="header-left">
                    <v-avatar size="32" color="white" class="mr-4">
                        <v-icon color="dark" size="24">mdi-upload</v-icon>
                    </v-avatar>
                    <span>Cargar Documentos</span>
                </div>
                <v-spacer></v-spacer>
                <v-btn icon @click="ShowDialog = false" color="white">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-col>
                <s-crud title="" :filter="filter" height="auto" :config="config" add :remove="selected.length > 0"
                    :edit="selected.length > 0" @edit="editar()" @rowSelected="rowSelected($event)"
                    @addEvent="cleanFields()" @save="save()" ref="crudfiles">
                    <template slot-scope="props">
                        <v-container fluid class="">
                            <v-row dense align="end">
                                <v-col lg="4" md="3" sm="6" cols="12">
                                    <s-select-definition label="Tipo de documento" :def="1596" v-model="item.SpcType"
                                        clearable @getDataInitial="getDataTypeDocuments($event)" />
                                </v-col>
                                <!-- <v-col lg="3" md="4" sm="6" cols="12"  colspan="2">
                                    <s-textarea v-model="item.observation" label="Observación"></s-textarea>
                                </v-col> -->
                                <v-col lg="3" md="3" sm="6" cols="12">
                                    <v-switch style="margin: 0; padding: 0;" v-model.lazy="SpcExpire" color="primary"
                                        inset hide-details label="TIEMPO DE VALIDÉZ"></v-switch>
                                </v-col>
                                <v-col lg="2" md="3" sm="6" v-if="SpcExpire">
                                    <s-date label="Fecha Inicio" v-model.lazy="item.SpcStartDate" dense
                                        hide-details></s-date>
                                </v-col>
                                <v-col lg="2" md="3" sm="6" v-if="SpcExpire">
                                    <s-date label="Fecha Expiración" v-model.lazy="item.SpcExpireDate" dense
                                        hide-details></s-date>
                                </v-col>
                                <v-col lg="5" md="6" sm="6" cols="12">
                                    <div class="striking-upload-box" :class="{ 'has-file': Attach }">
                                        <v-file-input v-model="Attach" id="Attach" hide-details prepend-icon=""
                                            class="invisible-input" :rules="[rulesFile]" />
                                        <div class="striking-content">
                                            <v-icon size="26" class="striking-icon">
                                                {{ Attach ? 'mdi-check-decagram' : 'mdi-cloud-upload' }}
                                            </v-icon>
                                            <div class="striking-text">
                                                <span class="striking-title">
                                                    {{ Attach ? 'Archivo Listo' : 'Seleccionar Archivo' }}</span>
                                                <span class="striking-subtitle">
                                                    {{ Attach ? Attach.name : 'Haz clic para explorar...' }}</span>
                                            </div>
                                        </div>
                                        <v-btn v-if="Attach" icon small class="striking-clear-btn"
                                            @click.stop.prevent="Attach = null" title="Quitar archivo">
                                            <v-icon size="18" color="white">mdi-close</v-icon>
                                        </v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>
                    </template>

                    <template v-slot:item.SpcFilename="{ item }">
                        <div class="text-truncate text-start" style="max-width: 300px;">
                            {{ item.SpcFilename }}
                        </div>
                    </template>

                    <template v-slot:item.SpcOptions="{ item }">
                        <v-tooltip bottom="">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" icon color="success" @click="download(item.SpcFilename)"
                                    title="Descargar">
                                    <v-icon>mdi-download</v-icon>
                                </v-btn>
                            </template>
                            <span>Descargar</span>
                        </v-tooltip>
                    </template>

                    <template v-slot:item.SpcStartDate="{ item }">
                        <div style="color:#aaa;" v-if="item.SpcStartDate">
                            {{ item.SpcStartDate ? $fun.formatDateView(item.SpcStartDate) : '' }}
                        </div>
                    </template>
                    <template v-slot:item.SpcExpireDate="{ item }">
                        <v-chip v-if="expiracion(item)" :color="expiracion(item)?.color" small
                            class="text-truncate text--light" style="color: #fff;font-size: 11px;padding: 2px 6px;">
                            {{ expiracion(item)?.texto }}
                        </v-chip>
                        <div style="color:#aaa;" v-if="item.SpcExpireDate">
                            {{ item.SpcExpireDate ? $fun.formatDateView(item.SpcExpireDate) : '' }}
                        </div>
                    </template>
                </s-crud>
            </v-col>
        </v-card>
    </v-dialog>
</template>

<script>
import _SpcDocumentService from "@/services/SupplyChain/Transport/SpcDocumentService.js";
import _sGeneral from "@/services/HelperService.js";
import _GenUploadFiles from "../../../services/General/GenUploadFiles";
import sTextarea from '@/components/Utils/sTextarea.vue';
import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
dayjs.extend(isSameOrAfter)

export default {
    components: { sTextarea },
    props: {
        SpcID: {
            type: Number,
            default: 0
        },
        dialogFiles: {
            type: Boolean,
            default: false
        },
    },
    data: () => ({
        filter: {
            SpcID: null
        },
        ShowDialog: false,
        SpcExpire: false,
        selected: [],
        Attach: null,
        formats_accepted: ["image/jpeg", "image/jpg", "image/png", "application/pdf"],
        max_size: 3145728,
        config: {
            model: {
                SpcdID: "ID",
                SpcFilename: "string",
                SpcID: "int",
                SpcOptions: ""
            },
            service: _SpcDocumentService,
            headers: [
                { text: "ID", value: "SpcdID" },
                { text: "Tipo Documento", value: "SpcTypeName", align: "left" },
                { text: "Nombre", value: "SpcFilename", align: "left" },
                { text: "Fecha Inicio", value: "SpcStartDate", align: "center" },
                { text: "Fecha Expiración", value: "SpcExpireDate", align: "center" },
                { text: "File", value: "SpcOptions", align: "center" },
            ],
        },
        item: {
            SpcdID: 0,
            SpcID: 0,
            SpcType: 0,
            SpcFilename: null,
            SpcStartDate: null,
            SpcExpireDate: null,
            SecStatus: 1,
            UsrCreateID: 0,
        }
    }),
    computed: {},
    watch: {
        dialogFiles(value) {
            this.ShowDialog = value
        },
        ShowDialog(value) {
            this.$emit('update:dialogFiles', value)
        },
        SpcID(value) {
            this.$nextTick(() => {
                this.filter = { SpcID: value }
                // this.$refs.crudfiles.refresh();
            });
        },
    },
    mounted() {
        this.filter = { SpcID: this.SpcID }
    },
    methods: {
        rowSelected(item) {
            if (item && item.length > 0) {
                this.selected = item;
                this.item = { ...item[0] };
                this.SpcExpire = false;
                if (this.item.SpcExpireDate) {
                    this.SpcExpire = true;
                }
            }
        },
        getDataTypeDocuments(items) {
            console.log(JSON.parse(JSON.stringify(items)))
        },
        rulesFile(file) {
            if (!file || file == null || file == undefined || !file) {
                this.Attach = null;
                return true;
            }
            if (!this.formats_accepted.includes(file.type)) {
                this.$fun.alert(`Formato de archivo no permitido: ${file.type}`, "warning");
                this.Attach = null;
                return `Formato de archivo no permitido: ${file.type}`;
            }
            if (file.size > this.max_size) {
                this.$fun.alert(`Tamaño de archivo excede el límite permitido: ${(this.max_size / 1024) / 1024}MB`);
                this.Attach = null;
                return `Tamaño de archivo excede el límite permitido: ${this.max_size}`;
            }
            return true;
        },
        validateFile() {
            if (this.Attach == null || this.Attach == undefined || !this.Attach) {
                this.$fun.alert("Seleccionar un archivo", "warning");
                return
            }
            if (!this.formats_accepted.includes(this.Attach.type)) {
                this.$fun.alert("Formato de archivo no permitido (3MB)", "warning");
                return;
            }
            if (this.Attach.size > this.max_size) {
                this.$fun.alert("Tamaño de archivo excede el límite permitido", "warning");
                return;
            }
            return true;
        },
        async save() {
            try {
                if (this.item.SpcType == null || this.item.SpcType == "") {
                    this.$fun.alert("Seleccionar tipo de documento", "warning");
                    return;
                }

                if (this.item.SpcdID == 0) {
                    const isFileValid = this.validateFile();
                    if (!isFileValid) return;
                }

                if (this.SpcExpire) {
                    if (this.item.SpcStartDate == null || this.item.SpcStartDate == "") {
                        this.$fun.alert("Seleccionar fecha de inicio", "warning");
                        return;
                    }
                    if (this.item.SpcExpireDate == null || this.item.SpcExpireDate == "") {
                        this.$fun.alert("Seleccionar fecha de expiración", "warning");
                        return;
                    }

                    const isMayor = this.esMayorOIgual();
                    if (!isMayor) {
                        this.$fun.alert("Fecha de expiración no puede ser inferior a inicio", "warning");
                        return;
                    }
                } else {
                    this.item.SpcStartDate = null
                    this.item.SpcExpireDate = null
                }

                let title = this.item.SpcdID > 0 ? 'Actualizar ' : 'Agregar nuevo ';
                const result = await this.$fun.alert(`${title} registro?`, "question");
                if (result.value) {
                    if (this.Attach) {
                        const filename = `Spc${this.filter.SpcID}_${Date.now()}`;
                        const respImg = await _GenUploadFiles.upload(this.Attach, filename, 'PathDocumentCarrier', true);
                        if (respImg.status !== 200) throw new Error(`Error al subir archivo en directorio.`);
                        this.item.SpcFilename = respImg.data.fileName;
                    }

                    this.item.SpcID = this.filter.SpcID;
                    this.item.UsrCreateID = this.$fun.getUserID();

                    const response = await _SpcDocumentService.save(this.item, this.$fun.getUserID());
                    if (response.status !== 200) throw new Error(`Error al registrar archivo.`);

                    this.$fun.alert("Se ha guardado correctamente", "success");
                    this.$refs.crudfiles.refresh();
                    this.cleanFields();
                }
            } catch (error) {
                if (error.response) {
                    // console.log(error.response.status);
                    // console.error(error.response.data.Message || 'Recurso no encontrado');
                } else if (error.request) {
                    console.error('No hubo respuesta del servidor');
                } else {
                    console.error('Error al configurar la solicitud:', error.message);
                }
            }
        },
        download(fileName) {
            if (fileName) {
                _GenUploadFiles.getFile("PathDocumentCarrier", `${fileName}`)
                    .then(resp => console.log('downloaded : ', resp))
                    .catch(error => console.error("Error al obtener imagen:", error));
            }
        },
        cleanFields() {
            this.Attach = null;
            this.SpcExpire = false;
            this.item = {
                SpcdID: 0,
                SpcID: 0,
                SpcType: 0,
                SpcFilename: null,
                SpcStartDate: null,
                SpcExpireDate: null,
                SecStatus: 1,
                UsrCreateID: 0,
            }
        },
        expiracion(item) {
            if (!item.SpcExpireDate) return null;

            const hoy = new Date();
            const vencimiento = new Date(item.SpcExpireDate);
            const diffTime = vencimiento - hoy;
            const diasRestantes = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            if (diasRestantes < 0) {
                return { color: 'red darken-2', texto: 'Vencido' };
            } else if (diasRestantes == 0) {
                return { color: 'yellow darken-2', texto: `Vence hoy` };
            } else if (diasRestantes == 1) {
                return { color: 'red', texto: `Vence mañana` };
            } else if (diasRestantes <= 7) {
                return { color: 'orange darken-3', texto: `Vence en ${diasRestantes} días` };
            } else if (diasRestantes <= 15) {
                return { color: 'amber darken-3', texto: 'Menos de 15 días' };
            } else if (diasRestantes <= 30) {
                return { color: 'yellow darken-2', texto: 'Menos de un mes' };
            } else {
                return null;
                // return { color: 'green darken-2', texto: `Faltan ${diasRestantes} días` };
            }
        },
        esMayorOIgual() {
            const startDate = dayjs(this.item.SpcStartDate, 'DD-MM-YYYY')
            const expireDate = dayjs(this.item.SpcExpireDate, 'DD-MM-YYYY')
            return expireDate.isSameOrAfter(startDate)
        }
    }
};
</script>

<style scoped>
.text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.gradient-primary {
    background: linear-gradient(135deg, #a4a4a4 29%, #322d38 100%);
}

.header-left {
    display: flex;
    align-items: center;
}

.header-right {
    display: flex;
    justify-items: center;
    align-items: center !important;
    min-width: 300px;
}

/* Diseño Profesional y Llamativo (Premium Dark Widget) */
.striking-upload-box {
    position: relative;
    width: 100%;
    height: 52px;
    background: linear-gradient(135deg, #322d38 0%, #1e1b22 100%);
    border-radius: 12px;
    border: 1px solid #4a4553;
    display: flex;
    align-items: center;
    padding: 0 16px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    margin-top: 2px;
}

.striking-upload-box:hover {
    border-color: #8c829e;
    background: linear-gradient(135deg, #403a47 0%, #28242e 100%);
    transform: translateY(-3px);
    box-shadow: 0 10px 22px rgba(0, 0, 0, 0.25);
}

.striking-upload-box.has-file {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    border-color: #34d399;
    box-shadow: 0 6px 15px rgba(16, 185, 129, 0.25);
}

.striking-upload-box.has-file:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 24px rgba(16, 185, 129, 0.35);
}

.striking-content {
    display: flex;
    align-items: center;
    width: 100%;
    pointer-events: none;
    /* Permite que el click pase al input invisible */
    z-index: 1;
}

.striking-icon {
    color: #e2e8f0 !important;
    transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.striking-upload-box.has-file .striking-icon {
    color: #ffffff !important;
}

.striking-upload-box:hover .striking-icon {
    transform: scale(1.15) rotate(-8deg);
    color: #ffffff !important;
}

.striking-text {
    display: flex;
    flex-direction: column;
    margin-left: 14px;
    overflow: hidden;
    width: 100%;
    padding-right: 36px;
}

.striking-title {
    font-size: 14px;
    font-weight: 700;
    color: #ffffff;
    line-height: 1.2;
    letter-spacing: 0.3px;
}

.striking-subtitle {
    font-size: 11.5px;
    font-weight: 500;
    color: #a7a1af;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 2px;
}

.striking-upload-box.has-file .striking-subtitle {
    color: #d1fae5;
}

.striking-clear-btn {
    position: absolute;
    right: 8px;
    z-index: 3;
    background-color: rgba(255, 255, 255, 0.15) !important;
    transition: all 0.2s ease;
}

.striking-clear-btn:hover {
    background-color: rgba(255, 255, 255, 0.35) !important;
    transform: scale(1.1);
}

.invisible-input {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0 !important;
    z-index: 2;
    cursor: pointer;
    margin: 0 !important;
    padding: 0 !important;
}

.invisible-input ::v-deep input {
    cursor: pointer !important;
    height: 100% !important;
}
</style>
